module.exports = __webpack_public_path__ + "img/host2.463561d6.png";